module.exports = "/365FarmNet/dist/cropSequenceCore.126de640ae4816186c94fa1954651e22.html";